"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removeSecondaryLanguageFromPathname = exports.getSecondaryLanguageFromPathname = exports.addSecondaryLanguageToPathname = void 0;
var getSecondaryLanguageFromPathname = function(pathname) {
    var _pathname_match;
    return (_pathname_match = pathname.match(/^\/([a-z]{2})\//)) === null || _pathname_match === void 0 ? void 0 : _pathname_match[0].replaceAll('/', '');
};
exports.getSecondaryLanguageFromPathname = getSecondaryLanguageFromPathname;
var removeSecondaryLanguageFromPathname = function(pathname) {
    var secondaryLanguage = getSecondaryLanguageFromPathname(pathname);
    return secondaryLanguage ? pathname.replace("/".concat(secondaryLanguage), '') : pathname;
};
exports.removeSecondaryLanguageFromPathname = removeSecondaryLanguageFromPathname;
var addSecondaryLanguageToPathname = function(pathname, currentPathname) {
    var secondaryLanguage = getSecondaryLanguageFromPathname(currentPathname);
    if (secondaryLanguage) {
        return pathname.replace(/^\//, "/".concat(secondaryLanguage, "/"));
    }
    return pathname;
};
exports.addSecondaryLanguageToPathname = addSecondaryLanguageToPathname; //# sourceMappingURL=secondaryLanguageUtils.js.map
